export const configureGantt = (gantt, rowHeight, cellWidth, gridWidth, showSubtasksRef) => {
    gantt.config.columns = [
        { name: "text", label: "Aircraft", width: gridWidth, tree: false, resize: false },
    ];
    gantt.config.grid_width = gridWidth;

    gantt.config.scales = [
        { unit: "month", step: 1, format: "%F, %Y", sticky: false },
        { unit: "day", step: 1, date: cellWidth < 12 ? "%j" : "%j %D", sticky: false },
        {
            unit: "hour",
            step: cellWidth < 6 ? 12 : cellWidth < 12 ? 6 : cellWidth < 18 ? 4 : cellWidth < 24 ? 2 : 1,
            date: "%G",
            sticky: false,
        },
    ];

    gantt.config.duration_unit = "hour";
    gantt.config.duration_step = 1;
    gantt.config.escape_html = false;
    gantt.config.scale_height = 60;
    gantt.config.row_height = rowHeight;
    gantt.config.min_column_width = cellWidth;
    gantt.config.show_links = true;
    gantt.config.links_same_row = true;
    gantt.config.readonly = true;
    gantt.config.layout = {
        css: "gantt_container",
        rows: [
            {
                cols: [
                    { view: "grid", scrollX: "scrollHor", scrollY: "scrollVer" },
                    { resizer: true, width: 4 },
                    { view: "timeline", scrollX: "scrollHor", scrollY: "scrollVer" },
                    { view: "scrollbar", id: "scrollVer" },
                ],
            },
            { view: "scrollbar", id: "scrollHor", height: 20 },
        ],
    };

    gantt.templates.task_text = (start, end, task) => {
        const fontSize = cellWidth < 200 ? '10px' : cellWidth < 300 ? '12px' : '14px';
        const subtasks = showSubtasksRef.current?.(task);
        if (subtasks) return subtasks;

        return `<span style="font-size:${fontSize}">
            <div class="flight-multi-line-text" data-id="${task.id}">
                ${task.text}
            </div>
        </span>`;
    };
};
